import React, { useState } from 'react';
import { UsersIcon, MessageSquareIcon, VideoIcon, CalendarIcon, SearchIcon } from 'lucide-react';
const Community = () => {
  const [activeTab, setActiveTab] = useState('forum');
  const [searchQuery, setSearchQuery] = useState('');
  const forumTopics = [{
    id: 1,
    title: '¿Cómo manejar cuando él ve y no responde?',
    author: 'Marina S.',
    replies: 24,
    lastActivity: 'hace 2 horas',
    tags: ['Protocolo de Emergencia', 'Nivel 2']
  }, {
    id: 2,
    title: '¡Resultados increíbles con el Disparador de Nostalgia!',
    author: 'Juliana M.',
    replies: 18,
    lastActivity: 'hace 5 horas',
    tags: ['Casos de Éxito', 'Disparadores']
  }, {
    id: 3,
    title: 'Identificando a un Cazador: consejos que funcionaron',
    author: 'Carla F.',
    replies: 32,
    lastActivity: 'hace 1 día',
    tags: ['Tipos Masculinos', 'Cazador']
  }, {
    id: 4,
    title: 'Él volvió a seguirme en redes sociales. ¿Qué hacer?',
    author: 'Patricia A.',
    replies: 15,
    lastActivity: 'hace 2 días',
    tags: ['Redes Sociales', 'Señales']
  }, {
    id: 5,
    title: '¿Cómo mantener la obsesión después de la reconquista?',
    author: 'Fernanda L.',
    replies: 27,
    lastActivity: 'hace 3 días',
    tags: ['Consolidación', 'Post-Reconquista']
  }];
  const groups = [{
    id: 1,
    name: 'Ex-Novios',
    members: 1243,
    description: 'Para mujeres que desean reconquistar ex-novios o ex-esposos.',
    lastActivity: 'Activo ahora'
  }, {
    id: 2,
    name: 'Crushes y Coqueteos',
    members: 876,
    description: 'Estrategias para transformar interés casual en obsesión.',
    lastActivity: 'Activo hace 10 minutos'
  }, {
    id: 3,
    name: 'Relaciones Largas',
    members: 654,
    description: 'Reavivando la chispa en relaciones de larga duración.',
    lastActivity: 'Activo hace 25 minutos'
  }, {
    id: 4,
    name: 'Protocolo de Emergencia',
    members: 932,
    description: 'Apoyo para situaciones críticas y resistencia extrema.',
    lastActivity: 'Activo hace 5 minutos'
  }];
  const upcomingEvents = [{
    id: 1,
    title: 'Workshop: Dominando los 7 Disparadores de Obsesión',
    date: '15 de Junio',
    time: '19:00 - 20:30',
    host: 'Dra. Camila Rodríguez',
    participants: 156
  }, {
    id: 2,
    title: 'Sesión de Preguntas y Respuestas En Vivo',
    date: '22 de Junio',
    time: '20:00 - 21:00',
    host: 'Equipo Mensajes Obsesivas',
    participants: 243
  }, {
    id: 3,
    title: 'Masterclass: Consolidación de la Reconquista',
    date: '30 de Junio',
    time: '19:00 - 21:00',
    host: 'Dra. Camila Rodríguez',
    participants: 189
  }];
  const experts = [{
    id: 1,
    name: 'Dra. Camila Rodríguez',
    role: 'Psicóloga y Especialista en Relaciones',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    availability: 'Disponible para chat'
  }, {
    id: 2,
    name: 'María Fernández',
    role: 'Coach de Relaciones',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    availability: 'Próxima sesión: 18/06'
  }, {
    id: 3,
    name: 'Dr. Andrés Martínez',
    role: 'Psicólogo Conductual',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    availability: 'Disponible para chat'
  }];
  const renderTabContent = () => {
    switch (activeTab) {
      case 'forum':
        return <div data-id="element-126">
            <div className="mb-6" data-id="element-127">
              <div className="relative" data-id="element-128">
                <input type="text" placeholder="Buscar en el foro..." className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E91E63]" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-129" />
                <SearchIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-130" />
              </div>
            </div>
            <div className="space-y-4" data-id="element-131">
              {forumTopics.map(topic => <div key={topic.id} className="border rounded-lg p-4 hover:border-[#E91E63] transition-colors" data-id="element-132">
                  <h3 className="font-medium text-[#2C2C2C] mb-2" data-id="element-133">
                    {topic.title}
                  </h3>
                  <div className="flex flex-wrap items-center text-sm text-gray-500 mb-3" data-id="element-134">
                    <span className="mr-4" data-id="element-135">Por: {topic.author}</span>
                    <span className="mr-4" data-id="element-136">{topic.replies} respuestas</span>
                    <span data-id="element-137">Actividad: {topic.lastActivity}</span>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-138">
                    {topic.tags.map((tag, idx) => <span key={idx} className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full" data-id="element-139">
                        {tag}
                      </span>)}
                  </div>
                </div>)}
            </div>
            <div className="mt-6 flex justify-center" data-id="element-140">
              <button className="bg-[#E91E63] text-white px-4 py-2 rounded-md hover:bg-[#D81B60]" data-id="element-141">
                Crear Nuevo Tema
              </button>
            </div>
          </div>;
      case 'groups':
        return <div className="space-y-6" data-id="element-142">
            {groups.map(group => <div key={group.id} className="border rounded-lg p-5 hover:border-[#E91E63] transition-colors" data-id="element-143">
                <div className="flex justify-between items-start mb-2" data-id="element-144">
                  <h3 className="font-bold text-lg" data-id="element-145">{group.name}</h3>
                  <span className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full" data-id="element-146">
                    {group.lastActivity}
                  </span>
                </div>
                <p className="text-gray-700 mb-3" data-id="element-147">{group.description}</p>
                <div className="flex justify-between items-center" data-id="element-148">
                  <span className="text-sm text-gray-500" data-id="element-149">
                    {group.members} miembros
                  </span>
                  <button className="bg-[#9C27B0] text-white px-3 py-1 rounded-md text-sm hover:bg-[#7B1FA2]" data-id="element-150">
                    Unirse
                  </button>
                </div>
              </div>)}
          </div>;
      case 'events':
        return <div className="space-y-6" data-id="element-151">
            {upcomingEvents.map(event => <div key={event.id} className="border rounded-lg p-5 hover:border-[#E91E63] transition-colors" data-id="element-152">
                <div className="flex items-start" data-id="element-153">
                  <div className="bg-[#9C27B0] text-white p-3 rounded-lg mr-4 text-center min-w-[60px]" data-id="element-154">
                    <div className="text-xs" data-id="element-155">JUN</div>
                    <div className="text-xl font-bold" data-id="element-156">
                      {event.date.split(' ')[0]}
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-157">
                    <h3 className="font-bold text-lg mb-1" data-id="element-158">{event.title}</h3>
                    <div className="flex flex-wrap items-center text-sm text-gray-500 mb-3" data-id="element-159">
                      <span className="flex items-center mr-4" data-id="element-160">
                        <ClockIcon size={14} className="mr-1" data-id="element-161" /> {event.time}
                      </span>
                      <span className="flex items-center mr-4" data-id="element-162">
                        <UsersIcon size={14} className="mr-1" data-id="element-163" />{' '}
                        {event.participants} participantes
                      </span>
                      <span className="flex items-center" data-id="element-164">
                        <VideoIcon size={14} className="mr-1" data-id="element-165" /> En vivo
                      </span>
                    </div>
                    <p className="text-gray-700" data-id="element-166">
                      Presentado por: {event.host}
                    </p>
                  </div>
                </div>
                <div className="mt-4 flex justify-end" data-id="element-167">
                  <button className="bg-[#E91E63] text-white px-4 py-2 rounded-md text-sm hover:bg-[#D81B60]" data-id="element-168">
                    Reservar Lugar
                  </button>
                </div>
              </div>)}
          </div>;
      case 'experts':
        return <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-169">
            {experts.map(expert => <div key={expert.id} className="border rounded-lg p-5 text-center hover:border-[#E91E63] transition-colors" data-id="element-170">
                <img src={expert.image} alt={expert.name} className="w-24 h-24 rounded-full object-cover mx-auto mb-4" data-id="element-171" />
                <h3 className="font-bold text-lg" data-id="element-172">{expert.name}</h3>
                <p className="text-sm text-gray-500 mb-3" data-id="element-173">{expert.role}</p>
                <div className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full inline-block mb-4" data-id="element-174">
                  {expert.availability}
                </div>
                <button className="w-full bg-[#9C27B0] text-white px-3 py-2 rounded-md hover:bg-[#7B1FA2]" data-id="element-175">
                  Agendar Consulta
                </button>
              </div>)}
          </div>;
      default:
        return null;
    }
  };
  return <div className="max-w-4xl mx-auto" data-id="element-176">
      <header className="mb-8 text-center" data-id="element-177">
        <h1 className="text-3xl font-bold text-[#2C2C2C] mb-2" data-id="element-178">Comunidad</h1>
        <p className="text-gray-600" data-id="element-179">
          Conéctate, aprende y comparte experiencias
        </p>
      </header>
      <div className="bg-white rounded-xl shadow-md p-6" data-id="element-180">
        <div className="flex overflow-x-auto mb-6 pb-2" data-id="element-181">
          <button className={`flex items-center px-4 py-2 mr-2 rounded-md whitespace-nowrap ${activeTab === 'forum' ? 'bg-[#E91E63] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveTab('forum')} data-id="element-182">
            <MessageSquareIcon size={18} className="mr-2" data-id="element-183" />
            Foro
          </button>
          <button className={`flex items-center px-4 py-2 mr-2 rounded-md whitespace-nowrap ${activeTab === 'groups' ? 'bg-[#E91E63] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveTab('groups')} data-id="element-184">
            <UsersIcon size={18} className="mr-2" data-id="element-185" />
            Grupos
          </button>
          <button className={`flex items-center px-4 py-2 mr-2 rounded-md whitespace-nowrap ${activeTab === 'events' ? 'bg-[#E91E63] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveTab('events')} data-id="element-186">
            <CalendarIcon size={18} className="mr-2" data-id="element-187" />
            Eventos
          </button>
          <button className={`flex items-center px-4 py-2 rounded-md whitespace-nowrap ${activeTab === 'experts' ? 'bg-[#E91E63] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveTab('experts')} data-id="element-188">
            <VideoIcon size={18} className="mr-2" data-id="element-189" />
            Especialistas
          </button>
        </div>
        {renderTabContent()}
      </div>
    </div>;
};
// Define ClockIcon since it's used but not imported
const ClockIcon = ({
  size,
  className
}: {
  size: number;
  className?: string;
}) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-190">
      <circle cx="12" cy="12" r="10" data-id="element-191"></circle>
      <polyline points="12 6 12 12 16 14" data-id="element-192"></polyline>
    </svg>;
};
export default Community;